import React, { useContext, useState, useEffect } from "react";

import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
// import {  Button, Grid } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { useTheme } from "@material-ui/core/styles";
import * as XLSX from "xlsx";

import { grey, blue } from "@material-ui/core/colors";
import { toast } from "react-toastify";

import MainContainer from "../../components/MainContainer";
import TabPanel from "../../components/TabPanel";
import TableAttendantsStatus from "../../components/Dashboard/TableAttendantsStatus";
import { isArray } from "lodash";

import { AuthContext } from "../../context/Auth/AuthContext";

import useDashboard from "../../hooks/useDashboard";
import useContacts from "../../hooks/useContacts";
import useMessages from "../../hooks/useMessages";
import { ChatsUser } from "./ChartsUser";
import DonutChart from "./ChartDonut";

import Filters from "./Filters";
import { isEmpty } from "lodash";
import moment from "moment";
import { ChartsDate } from "./ChartsDate";
import ChartsSalesLine from "./ChartsSalesLine";
import TableUserValues from "./TableUserValues";
import {
  Avatar,
  Button,
  Card,
  CardContent,
  Container,
  Stack,
  SvgIcon,
  Tab,
  Tabs,
  LinearProgress,
  Box,
  Divider,
} from "@mui/material";
import { i18n } from "../../translate/i18n";
import ForbiddenPage from "../../components/ForbiddenPage";

const useStyles = makeStyles((theme) => ({
  overline: {
    fontSize: "0.9rem",
    fontWeight: 700,
    color: theme.palette.text.secondary,
    letterSpacing: "0.5px",
    lineHeight: 2.5,
    textTransform: "uppercase",
    fontFamily: "'Poppins', sans-serif'",
  },
  h4: {
    fontFamily: "'Poppins', sans-serif'",
    fontWeight: 500,
    fontSize: "2rem",
    lineHeight: 1,
    color: theme.palette.text.primary,
  },
  tab: {
    minWidth: "auto",
    width: "auto",
    padding: theme.spacing(0.5, 1),
    borderRadius: 8,
    transition: "0.3s",
    borderWidth: "1px",
    borderStyle: "solid",
    marginRight: theme.spacing(0.5),
    marginLeft: theme.spacing(0.5),

    [theme.breakpoints.down("lg")]: {
      fontSize: "0.9rem",
      padding: theme.spacing(0.4, 0.8),
      marginRight: theme.spacing(0.4),
      marginLeft: theme.spacing(0.4),
    },
    [theme.breakpoints.down("md")]: {
      fontSize: "0.8rem",
      padding: theme.spacing(0.3, 0.6),
      marginRight: theme.spacing(0.3),
      marginLeft: theme.spacing(0.3),
    },
    "&:hover": {
      backgroundColor: "rgba(6, 81, 131, 0.3)",
    },
    "&$selected": {
      color: theme.palette.primary.contrastText,
      backgroundColor: theme.palette.primary.main,
    },
  },
  tabIndicator: {
    borderWidth: "2px",
    borderStyle: "solid",
    height: 6,
    bottom: 0,
    color:
      theme.palette.mode === "light"
        ? theme.palette.primary.main
        : theme.palette.primary.contrastText,
  },
  container: {
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
  },
  nps: {
    paddingTop: theme.spacing(1),
    paddingBottom: theme.padding,
  },
  fixedHeightPaper: {
    padding: theme.spacing(2),
    display: "flex",
    flexDirection: "column",
    height: 240,
    overflowY: "auto",
    ...theme.scrollbarStyles,
  },
  cardAvatar: {
    fontSize: "55px",
    color: theme.palette.text.primary,
    backgroundColor: theme.palette.background.paper,
    width: theme.spacing(7),
    height: theme.spacing(7),
  },
  cardTitle: {
    fontSize: "18px",
    color: theme.palette.primary.main,
  },
  cardSubtitle: {
    color: theme.palette.text.secondary,
    fontSize: "14px",
  },
  alignRight: {
    textAlign: "right",
  },
  fullWidth: {
    width: "100%",
  },
  selectContainer: {
    width: "100%",
    textAlign: "left",
  },
  iframeDashboard: {
    width: "100%",
    height: "calc(100vh - 64px)",
    border: "none",
  },
  dashboardContainer: {
    display: "flex",
    flexDirection: "column",
    gap: 8,
    width: "100%",
  },
  filterContainer: {
    display: "flex",
    justifyContent: "flex-end",
  },
  filterSection: {
    width: "100%",
  },
  chartsContainer: {
    display: "flex",
    flexWrap: "wrap",
    gap: theme.spacing(3),
    width: "100%",
    padding: "12px",
    borderRadius: 8,
    border: `1px solid ${theme.mode === "light" ? "#f3f4f6" : "#121216"}`,
    backgroundColor: theme.palette.background.paper,
    [theme.breakpoints.down("sm")]: {
      padding: "8px",
      gap: theme.spacing(2),
    }
  },
  chartItem: {
    flex: "1 1 100%",
    minWidth: 280,
    display: "flex",
    flexDirection: "column",
    [theme.breakpoints.up("md")]: {
      flex: "1 1 45%",
    }
  },
  chartPaper: {
    padding: theme.spacing(2),
    height: "100%",
  },
  tableContainer: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    padding: "12px",
    borderRadius: 8,
    gap: theme.spacing(1),
    border: `1px solid ${theme.mode === "light" ? "#f3f4f6" : "#121216"}`,
    backgroundColor: theme.palette.background.paper,
  },
  tablePaper: {
    
  },
  customFixedHeightPaperLg: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
    height: "100%",
  },
  sectionTitle: {
    fontSize: "1.5rem",
    fontWeight: 700,
    color: theme.palette.primary.main,
    marginBottom: theme.spacing(2),
  },
  mainPaper: {
    flex: 1,
    padding: "0 50px",
    overflowY: "auto",
    overflowX: "hidden",
    ...theme.scrollbarStyles,
    backgroundColor: "transparent !important",
    borderRadius: "10px",
    [theme.breakpoints.down("sm")]: {
      padding: "0 10px",
      paddingBottom: "50px", // Espaço reservado para o MobileNavbar não sobrepor o conteúdo
    }
  },
  dashboardHeader: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "12px",
    borderRadius: 8,
    border: `1px solid ${theme.mode === "light" ? "#f3f4f6" : "#121216"}`,
    backgroundColor: theme.palette.background.paper,
    [theme.breakpoints.down("sm")]: {
      padding: "8px 12px",
    }
  },
  dashboardTitle: {
    fontFamily: "'Poppins', sans-serif",
    fontSize: "2rem",
    fontWeight: 700,
    color: theme.palette.primary.main,
    lineHeight: 1.2,
    [theme.breakpoints.down("sm")]: {
      fontSize: "1.5rem",
    }
  },
  dashboardSubtitle: {
    fontFamily: "'Poppins', sans-serif",
    fontSize: "1rem",
    color: theme.mode === "light" ? "#54656F" : "#FAFAFA",
    marginTop: theme.spacing(0.5),
  },
  mainSection: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))",
    gap: 16,
    width: "100%",
  },
  complexCard: {
    padding: 16,
    borderRadius: 8,
    backgroundColor: theme.palette.background.paper,
    display: "flex",
    flexDirection: "column",
    gap: 8,
    border: `1px solid ${theme.mode === "light" ? "#f3f4f6" : "#121216"}`,
  },
  complexCardHeader: {
    display: "flex",
    alignItems: "center",
    gap: 10,
  },
  complexCardIcon: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "20px",
    borderRadius: 12,
    color: theme.palette.primary.main,
  },
  complexCardTitle: {
    fontFamily: "'Poppins', sans-serif",
    fontSize: "0.8rem",
    fontWeight: 600,
    color: theme.palette.text.primary,
  },
  complexCardBody: {
    display: "flex",
    flexDirection: "column",
  },
  complexCardValue: {
    fontFamily: "'Poppins', sans-serif",
    fontSize: "1.5rem",
    fontWeight: 700,
    lineHeight: 1.2,
    color: theme.palette.text.primary,
  },
  complexCardTrendContainer: {
    display: "flex",
    alignItems: "center",
    marginTop: theme.spacing(0.5),
  },
  complexCardSegments: {
    display: "flex",
    width: "100%",
    height: 8,
    borderRadius: 4,
    overflow: "hidden",
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(1.5),
    backgroundColor: theme.palette.mode === "light" ? "#f5f5f5" : "#424242",
  },
  complexCardSegmentItem: {
    height: "100%",
    transition: "width 0.5s ease-in-out",
  },
  complexCardDataList: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(1.5),
  },
  complexCardDataItem: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    fontSize: "0.95rem",
  },
  complexCardDataLabelInfo: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1.2),
  },
  complexCardDataDot: {
    width: 12,
    height: 12,
    borderRadius: "50%",
  },

  fluxoCardsWrapper: {
    display: "flex",
    flexWrap: "wrap",
    gap: "8px",
    flexDirection: "row",
  },

  typographySubTexto: {
    fontFamily: "'Poppins', sans-serif",
    fontSize: "0.8rem",
    lineHeight: 1.43,
    color: theme.mode === "light" ? "#54656F" : "#c0cad9",
  },
  typographySubTitulos: {
    fontFamily: "'Poppins', sans-serif",
    fontSize: "1rem",
    fontWeight: 500,
    color: theme.mode === "light" ? "#1D1D1F" : "#c0cad9",
    marginBottom: "10px",
  },
  sectionContainer: {
    width: "100%",
    display: "flex",
    backgroundColor: theme.palette.background.paper,
    borderRadius: 8,
    padding: 16,
    border: `1px solid ${theme.mode === "light" ? "#e5e5e5" : "#11151a"}`,
    gap: theme.spacing(2),
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
    }
  },
  fluxoContainer: {
    display: "flex",
    flexDirection: "column",
    width: "65%",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    }
  },
  npsContainer: {
    display: "flex",
    flexDirection: "column",
    width: "35%",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    }
  },
  sectionHeader: {
    display: "flex",
    alignItems: "center",
    marginBottom: theme.spacing(2),
  },
  fluxoCardItem: {
    display: "flex",
    flex: "1 1 140px",
  },
  metricCard: {
    width: "100%",
    padding: theme.spacing(2.5),
    minHeight: 100,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "flex-start",
    gap: theme.spacing(1),
    borderRadius: 16,
    backgroundColor: theme.palette.background.paper,
    border: `1px solid ${theme.mode === "light" ? "#e5e5e5" : "#11151a"}`,
    boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.05)",
  },
  metricCardIconWrapper: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: 20,
    height: 20,
    borderRadius: 12,
    color: theme.mode === "light" ? "#54656F" : "#54656F",
  },
  metricIcon: {
    fontSize: "1rem",
  },
  metricValue: {
    fontFamily: "'Poppins', sans-serif",
    fontSize: "1rem",
    fontWeight: 700,
    lineHeight: 1.2,
    color: theme.mode === "light" ? "#1D1D1F" : "#c0cad9",
  },
  metricLabel: {
    fontFamily: "'Poppins', sans-serif",
    fontSize: "0.85rem",
    fontWeight: 400,
    color: theme.mode === "light" ? "#54656F" : "#54656F",
  },
  npsCard: {
    padding: theme.spacing(3),
    borderRadius: 16,
    backgroundColor: theme.palette.background.paper,
    border: `1px solid ${theme.mode === "light" ? "#e5e5e5" : "#11151a"}`,
    boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.05)",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(3.5),
  },
  npsItemContainer: {
    display: "flex",
    flexDirection: "column",
  },
  npsItemHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: theme.spacing(1),
  },
  npsItemLabel: {
    fontFamily: "'Poppins', sans-serif",
    fontSize: "0.95rem",
    fontWeight: 600,
    color: theme.mode === "light" ? "#1D1D1F" : "#c0cad9",
  },
  npsItemValue: {
    fontFamily: "'Poppins', sans-serif",
    fontSize: "0.95rem",
    fontWeight: 700,
  },
  npsItemProgressBar: {
    height: 7,
    borderRadius: 4,
  },
  conversionMetricsSection: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(2),
    width: "100%",
    marginTop: theme.spacing(2),
  },
  conversionMetricsHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: theme.spacing(2),
    backgroundColor: theme.palette.background.paper,
    borderRadius: 8,
    border: `1px solid ${theme.mode === "light" ? "#d8e3ff" : "#121216"}`,
  },
  conversionMetricsTitle: {
    fontFamily: "'Poppins', sans-serif",
    fontSize: "1.25rem",
    fontWeight: 600,
    color: theme.mode === "light" ? "#0e1433" : "#FAFAFA",
  },
  conversionMetricsFiltersBtn: {
    backgroundColor: theme.palette.background.paper,
    border: `0.5px solid ${theme.mode === "light" ? "#dce5ff" : "#333"}`,
    borderRadius: 5,
    boxShadow: "1px 1px 2px rgba(0, 0, 0, 0.1)",
    textTransform: "none",
    fontFamily: "'Poppins', sans-serif",
    fontWeight: 500,
    color: "#797e8c",
    fontSize: "0.75rem",
  },
  conversionCardsContainer: {
    display: "grid",
    gridTemplateColumns: "2fr 1fr 1fr",
    gap: theme.spacing(2),
    [theme.breakpoints.down("md")]: {
      gridTemplateColumns: "1fr",
    }
  },
  conversionCard: {
    padding: theme.spacing(2),
    borderRadius: 8,
    backgroundColor: theme.palette.background.paper,
    border: `1px solid ${theme.mode === "light" ? "#f3f4f6" : "#121216"}`,
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(1),
  },
  conversionCardLarge: {
    flexDirection: "row",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
    }
  },
  conversionCardCol: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(1),
  },
  conversionCardColRight: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(1),
    paddingLeft: theme.spacing(2),
    borderLeft: `1px solid ${theme.palette.divider}`,
    [theme.breakpoints.down("sm")]: {
      paddingLeft: 0,
      borderLeft: "none",
      borderTop: `1px solid ${theme.palette.divider}`,
      paddingTop: theme.spacing(2),
    }
  },
  metricListItem: {
    display: "flex",
    justifyContent: "space-between",
    padding: "6px 0",
    borderBottom: `1px solid ${theme.mode === "light" ? "#f0f0f0" : "#2c2c2c"}`,
    fontFamily: "'Poppins', sans-serif",
  },
  conversionRateBox: {
    marginTop: "auto",
    padding: theme.spacing(1.5),
    backgroundColor: theme.mode === "light" ? "#0051ff17" : "#0ff05a18",
    color: theme.mode === "light" ? "#0051ff" : "#0ff05a",
    borderRadius: 8,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    fontFamily: "'Poppins', sans-serif",
  },
  conversionCardHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  conversionCardTitle: {
    fontFamily: "'Poppins', sans-serif",
    fontSize: "1rem",
    fontWeight: 600,
    color: theme.palette.text.primary,
  },
  conversionCardToggle: {
    display: "flex",
    gap: 4,
    backgroundColor: theme.mode === "light" ? "#f3f4f6" : "#2a2a2a",
    padding: 2,
    borderRadius: 4,
  },
  conversionToggleBtn: {
    padding: "2px 8px",
    fontSize: "0.75rem",
    borderRadius: 4,
    cursor: "pointer",
    border: "none",
    backgroundColor: "transparent",
    color: theme.palette.text.secondary,
    fontFamily: "'Poppins', sans-serif",
    "&.active": {
      backgroundColor: theme.palette.background.paper,
      color: theme.palette.primary.main,
      boxShadow: "0 1px 2px rgba(0,0,0,0.1)",
      fontWeight: 600,
    }
  },
  conversionList: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(1),
    marginTop: theme.spacing(2),
    overflowY: "auto",
    maxHeight: 220,
    ...theme.scrollbarStyles,
  },
  customLegendContainer: {
    display: "flex",
    flexWrap: "wrap",
    gap: theme.spacing(1),
    justifyContent: "center",
    marginTop: theme.spacing(1),
  },
  customLegendItem: {
    display: "flex",
    alignItems: "center",
    gap: 4,
    fontSize: "0.75rem",
    color: theme.palette.text.secondary,
    fontFamily: "'Poppins', sans-serif",
  },
  conversionListItem: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: theme.spacing(1.5),
    borderRadius: 6,
    backgroundColor: theme.mode === "light" ? "#fafafa" : "#1e1e1e",
    border: `1px solid ${theme.mode === "light" ? "#f0f0f0" : "#2c2c2c"}`,
  },
  conversionItemName: {
    fontSize: "0.85rem",
    fontWeight: 500,
    fontFamily: "'Poppins', sans-serif",
    color: theme.palette.text.primary,
  },
  conversionItemStats: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(2),
    fontSize: "0.85rem",
    fontFamily: "'Poppins', sans-serif",
    color: theme.palette.text.secondary,
  },
  conversionItemValue: {
    fontWeight: 600,
    color: theme.palette.text.primary,
  },
  conversionTotalRow: {
    display: "flex",
    justifyContent: "space-between",
    marginTop: "auto",
    paddingTop: theme.spacing(2),
    borderTop: `1px solid ${theme.mode === "light" ? "#eee" : "#333"}`,
    fontWeight: 600,
    fontSize: "0.85rem",
    fontFamily: "'Poppins', sans-serif",
    color: theme.palette.text.primary,
  }
}));

const formatCurrency = (value) => {
  const numericValue = Number(value);
  return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(isNaN(numericValue) ? 0 : numericValue);
};

const ComplexHeroCard = ({ title, icon, mainValue, trendLabel, segments, data, classes }) => {
  return (
    <Paper className={classes.complexCard} elevation={0}>
      <div className={classes.complexCardHeader}>
         {icon && <div className={classes.complexCardIcon}>{icon}</div>}
         <Typography className={classes.complexCardTitle}>{title}</Typography>
      </div>
      <div className={classes.complexCardBody}>
         <Typography className={classes.complexCardValue}>{mainValue}</Typography>
         {trendLabel && (
           <div className={classes.complexCardTrendContainer}>
             <Typography className={classes.typographySubTexto} color="textSecondary">{trendLabel}</Typography>
           </div>
         )}
      </div>
              {segments && segments.length > 0 && (
                <div className={classes.complexCardSegments}>
                   {segments.map((seg, i) => (
                      <div key={i} className={classes.complexCardSegmentItem} style={{ backgroundColor: seg.color, width: seg.percent , fontSize: "0.7rem"}} />
                   ))}
                </div>
              )}
              {data && data.length > 0 && (
                <div className={classes.complexCardDataList}>
                   {data.map((item, i) => (
                      <div key={i} className={classes.complexCardDataItem}>
                         <div className={classes.complexCardDataLabelInfo}>
                           <div className={classes.complexCardDataDot} style={{ backgroundColor: item.color }} />
                           <Typography className={classes.typographySubTexto} style={{ color: "textSecondary" }}>{item.label}</Typography>
                         </div>
                         <Typography className={classes.typographySubTexto} style={{ fontWeight: 600 }}>{item.value}</Typography>
                      </div>
                   ))}
                </div>
              )}
    </Paper>
  );
};

const Dashboard = () => {
  const theme = useTheme();
  const classes = useStyles();
  const [counters, setCounters] = useState({});
  const [attendants, setAttendants] = useState([]);
  const [filterType, setFilterType] = useState(1);
  const [period, setPeriod] = useState(0);
  const [dateFrom, setDateFrom] = useState(
    moment("1", "D").format("YYYY-MM-DD")
  );
  const [dateTo, setDateTo] = useState(moment().format("YYYY-MM-DD"));
  const [loading, setLoading] = useState(false);
  const { find } = useDashboard();

  //FILTROS NPS
  const [tab, setTab] = useState("Indicadores");
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [selectedQueues, setSelectedQueues] = useState([]);

  let newDate = new Date();
  let date = newDate.getDate();
  let month = newDate.getMonth() + 1;
  let year = newDate.getFullYear();
  let nowIni = `${year}-${month < 10 ? `0${month}` : `${month}`}-01`;

  let now = `${year}-${month < 10 ? `0${month}` : `${month}`
    }-${date < 10 ? `0${date}` : `${date}`}`;

  const [showFilter, setShowFilter] = useState(false);
  const [dateStartTicket, setDateStartTicket] = useState(nowIni);
  const [dateEndTicket, setDateEndTicket] = useState(now);
  const [queueTicket, setQueueTicket] = useState(false);
  const [fetchDataFilter, setFetchDataFilter] = useState(false);

  // Mock Data e Estado para o Layout das Métricas de Conversão
  const [viewMode, setViewMode] = useState("oportunidades"); // "oportunidades" ou "leads"
  const [conversionToggle, setConversionToggle] = useState("atendente");

  const { user } = useContext(AuthContext);

  const exportarGridParaExcel = () => {
    const ws = XLSX.utils.table_to_sheet(
      document.getElementById("grid-attendants")
    );
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "RelatorioDeAtendentes");
    XLSX.writeFile(wb, "relatorio-de-atendentes.xlsx");
  };

  var userQueueIds = [];

  if (user.queues && user.queues.length > 0) {
    userQueueIds = user.queues.map((q) => q.id);
  }

  useEffect(() => {
    let isMounted = true;
    
    async function firstLoad() {
      if (isMounted) {
        console.log('Executando firstLoad...');
        await fetchData();
      }
    }
    
    const timeoutId = setTimeout(() => {
      firstLoad();
    }, 500);
    
    return () => {
      isMounted = false;
      clearTimeout(timeoutId);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fetchDataFilter]);

  async function fetchData() {
    setLoading(true);
    console.log('Iniciando fetchData...');
  
    let params = {};
  
    // Construir parâmetros de filtro
    if (period > 0) {
      params = {
        days: period,
      };
      console.log('Usando filtro por dias:', period);
    } else {
      // Se não há período específico, usar as datas
      if (!isEmpty(dateStartTicket) && moment(dateStartTicket).isValid()) {
        params = {
          ...params,
          date_from: moment(dateStartTicket).format("YYYY-MM-DD"),
        };
        console.log('Data de início:', dateStartTicket);
      }
  
      if (!isEmpty(dateEndTicket) && moment(dateEndTicket).isValid()) {
        params = {
          ...params,
          date_to: moment(dateEndTicket).format("YYYY-MM-DD"),
        };
        console.log('Data de fim:', dateEndTicket);
      }
    }
  
    // Se nenhum parâmetro foi definido, usar período padrão de 30 dias
    if (Object.keys(params).length === 0) {
      console.log('Nenhum filtro definido, usando 30 dias como padrão');
      params = { days: 30 };
    }
  
    console.log('Parâmetros finais para busca:', params);
  
    try {
      const data = await find(params);
      console.log('Dados recebidos no componente:', data);
  
      // Garantir que counters sempre tenha valores válidos
      const safeCounters = data.counters || {};
      
      // Verificar especificamente o campo tickets
      console.log('Campo tickets recebido:', safeCounters.tickets);
      
      setCounters(safeCounters);
      
      if (isArray(data.attendants)) {
        setAttendants(data.attendants);
      } else {
        console.warn('Attendants não é um array:', data.attendants);
        setAttendants([]);
      }
  
      console.log('Estado atualizado - Counters:', safeCounters);
      console.log('Estado atualizado - Attendants:', data.attendants);
      
      // Log específico para verificar se o campo tickets está presente
      console.log('Valor de tickets no estado:', safeCounters.tickets);
    } catch (error) {
      console.error('Erro ao buscar dados:', error);
      toast.error('Erro ao carregar dados do dashboard');
      
      // Definir valores padrão em caso de erro
      setCounters({
        avgSupportTime: 0,
        avgWaitTime: 0,
        supportFinished: 0,
        supportHappening: 0,
        supportPending: 0,
        supportGroups: 0,
        leads: 0,
        activeTickets: 0,
        passiveTickets: 0,
        tickets: 0,
        waitRating: 0,
        withoutRating: 0,
        withRating: 0,
        percRating: 0,
        npsPromotersPerc: 0,
        npsPassivePerc: 0,
        npsDetractorsPerc: 0,
        npsScore: 0
      });
      setAttendants([]);
    } finally {
      setLoading(false);
    }
  }

  const handleSelectedUsers = (selecteds) => {
    const users = selecteds.map((t) => t.id);
    setSelectedUsers(users);
  };

  const handleChangeTab = (e, newValue) => {
    setTab(newValue);
  };

  function formatTime(minutes) {
    const parsedMinutes = parseFloat(minutes);
    if (isNaN(parsedMinutes) || parsedMinutes <= 0) return "00h 00m";
    const hrs = Math.floor(parsedMinutes / 60);
    const mins = Math.floor(parsedMinutes % 60);
    return `${hrs.toString().padStart(2, '0')}h ${mins.toString().padStart(2, '0')}m`;
  }

  const GetUsers = () => {
    let count;
    let userOnline = 0;
    attendants.forEach((user) => {
      if (user.online === true) {
        userOnline = userOnline + 1;
      }
    });
    count = userOnline === 0 ? 0 : userOnline;
    return count;
  };

  const GetContacts = (all) => {
    let props = {};
    if (all) {
      props = {};
    } else {
      props = {
        dateStart: dateStartTicket,
        dateEnd: dateEndTicket,
      };
    }
    const { count } = useContacts(props);
    return count;
  };

  const GetMessages = (all, fromMe) => {
    let props = {};
    if (all) {
      if (fromMe) {
        props = {
          fromMe: true,
        };
      } else {
        props = {
          fromMe: false,
        };
      }
    } else {
      if (fromMe) {
        props = {
          fromMe: true,
          dateStart: dateStartTicket,
          dateEnd: dateEndTicket,
        };
      } else {
        props = {
          fromMe: false,
          dateStart: dateStartTicket,
          dateEnd: dateEndTicket,
        };
      }
    }
    const { count } = useMessages(props);
    return count;
  };

  function toggleShowFilter() {
    setShowFilter(!showFilter);
  }

  // Cálculos consolidados para os Hero Cards

  const totalAtendimentos = (counters.supportHappening || 0) + (counters.supportPending || 0) + (counters.supportFinished || 0);
  const happeningPerc = totalAtendimentos > 0 ? ((counters.supportHappening || 0) / totalAtendimentos) * 100 : 0;
  const pendingPerc = totalAtendimentos > 0 ? ((counters.supportPending || 0) / totalAtendimentos) * 100 : 0;
  const finishedPerc = totalAtendimentos > 0 ? ((counters.supportFinished || 0) / totalAtendimentos) * 100 : 0;

  const tktActives = counters.activeTickets || 0;
  const tktPassives = counters.passiveTickets || 0;
  const totalTkts = tktActives + tktPassives;
  const activesPerc = totalTkts > 0 ? (tktActives / totalTkts) * 100 : 0;
  const passivesPerc = totalTkts > 0 ? (tktPassives / totalTkts) * 100 : 0;

  // Cálculos para o Card de Valores e Oportunidades
  const totalSalesValue = counters.totalSalesValue || 0;
  const averageSalesValue = counters.averageSalesValue || 0;
  const happeningSalesValue = counters.happeningSalesValue || 0;
  const happeningAverageSalesValue = counters.happeningAverageSalesValue || 0;
  const ticketsInNegotiationTotal = counters.ticketsInNegotiationTotal || 0;
  const topKanbanValue = counters.topKanbanValue || 0;
  const topKanbanName = counters.topKanbanName || "N/A";

  // Agrupamento de dados para o bloco de Fluxo e Operação
  const fluxoOperacaoData = [
    { label: "Atendentes Ativos", value: `${GetUsers()}/${attendants.length}`, icon: "ri-user-voice-line" },
    { label: "Novos Contatos", value: counters.leads || 0, icon: "ri-user-add-line" },
    { label: "Grupos Ativos", value: counters.supportGroups || 0, icon: "ri-group-line" },
    { label: "Mensagens Rec.", value: `${GetMessages(false, false)}/${GetMessages(true, false)}`, icon: "ri-message-3-line" },
    { label: "Mensagens Env.", value: `${GetMessages(false, true)}/${GetMessages(true, true)}`, icon: "ri-send-plane-line" },
    { label: "T.M. Atendimento", value: formatTime(counters.avgSupportTime), icon: "ri-timer-line" },
    { label: "T.M. Espera", value: formatTime(counters.avgWaitTime), icon: "ri-hourglass-line" },
    { label: "Aguardando", value: counters.supportPending || 0, icon: "ri-time-line" },
    { label: "Finalizados", value: counters.supportFinished || 0, icon: "ri-check-double-line" },
  ];

  const npsData = [
    { label: "Índice de Avaliação", value: counters.percRating || 0, color: "#8B5CF6", isPercent: true },
    { label: "Score Geral (NPS)", value: counters.npsScore || 0, color: theme.palette.primary.main, isScore: true },
    { label: "Promotores", value: counters.npsPromotersPerc || 0, color: "#10B981" },
    { label: "Neutros", value: counters.npsPassivePerc || 0, color: "#F59E0B" },
    { label: "Detratores", value: counters.npsDetractorsPerc || 0, color: "#EF4444" },
  ];

  // Mapeamento de dados reais do Backend
  const rawMetrics = counters.metrics || {};
  const activeMetrics = rawMetrics[viewMode] || {
    total: 0, vendasFechadas: 0, fechados: 0, abertos: 0, pendentes: 0, taxaConversao: 0, donutDataAtendente: [], donutDataFila: [], metricsAtendentes: [], metricsFilas: []
  };

  const mockConversionGeneral = {
    total: activeMetrics.total || 0,
    vendasFechadas: activeMetrics.vendasFechadas || 0,
    fechados: activeMetrics.fechados || 0,
    abertos: activeMetrics.abertos || 0,
    pendentes: activeMetrics.pendentes || 0,
    taxaConversao: activeMetrics.total > 0 ? ((activeMetrics.vendasFechadas / activeMetrics.total) * 100).toFixed(1) : 0,
    donutDataAtendente: activeMetrics.donutDataAtendente?.length > 0 ? activeMetrics.donutDataAtendente : [{ name: "Sem vendas", value: 1 }],
    donutDataFila: activeMetrics.donutDataFila?.length > 0 ? activeMetrics.donutDataFila : [{ name: "Sem vendas", value: 1 }],
  };
  const mockConversionAtendentes = activeMetrics.metricsAtendentes || [];
  const mockConversionFilas = activeMetrics.metricsFilas || [];

  // Variáveis auxiliares para o Card 1
  const currentDonutData = conversionToggle === 'atendente' ? mockConversionGeneral.donutDataAtendente : mockConversionGeneral.donutDataFila;
  const totalDonutValue = currentDonutData.reduce((acc, curr) => acc + curr.value, 0);
  const donutColorPalette = ["#00E396", "#008FFB", "#FEB019", "#FF4560", "#775DD0", "#3F51B5", "#03A9F4", "#4CAF50", "#F9CE1D", "#FF9800"];
  const redDonutColorPalette = ["#EF4444", "#DC2626", "#B91C1C", "#991B1B", "#7F1D1D", "#F87171", "#E53935", "#C62828", "#D32F2F", "#B71C1C"];
  
  // Media de conversão das filas
  const mediaTaxaFilas = mockConversionFilas.length > 0 
    ? (mockConversionFilas.reduce((acc, curr) => acc + parseFloat(curr.taxa), 0) / mockConversionFilas.length).toFixed(1) 
    : 0;

  // Media de conversão dos atendentes
  const mediaTaxaAtendentes = mockConversionAtendentes.length > 0 
    ? (mockConversionAtendentes.reduce((acc, curr) => acc + parseFloat(curr.taxa), 0) / mockConversionAtendentes.length).toFixed(1) 
    : 0;

  // Destaque para o gráfico de Donut (Melhor Faturamento para Atendente / Maior Volume para Fila)
  const currentMetricsList = conversionToggle === 'atendente' ? mockConversionAtendentes : mockConversionFilas;
  const isValueMode = viewMode === 'oportunidades' && conversionToggle === 'atendente';
  let bestName = "Nenhum";
  let bestRate = isValueMode ? "R$ 0" : "0";
  
  if (currentMetricsList && currentMetricsList.length > 0) {
    const best = currentMetricsList.reduce((prev, current) => {
      if (isValueMode) {
        const prevVal = parseFloat(prev.valor) || 0;
        const currVal = parseFloat(current.valor) || 0;
        return (currVal > prevVal) ? current : prev;
      } else {
        const prevVal = parseFloat(prev.vendas) || 0;
        const currVal = parseFloat(current.vendas) || 0;
        return (currVal > prevVal) ? current : prev;
      }
    });

    if (isValueMode && parseFloat(best.valor) > 0) {
      bestName = best.nome ? best.nome.split(' ')[0] : "Desconhecido"; // Exibe apenas o primeiro nome
      bestRate = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL', maximumFractionDigits: 0 }).format(best.valor);
    } else if (!isValueMode && parseInt(best.vendas) > 0) {
      bestName = best.nome ? best.nome.split(' ')[0] : "Desconhecida";
      bestRate = best.vendas.toString();
    }
  }

  return (
    <>
      {user.profile === "user" && user.showDashboard === "disabled" ? (
        <ForbiddenPage />
      ) : (
        <MainContainer>
          <Paper
            className={classes.mainPaper}
          >
            <Container maxWidth={false} className={classes.container} style={{ padding: '16px 8px', maxWidth: '100%', overflowX: 'hidden' }}>
              <div className={classes.dashboardContainer}>
                {/* Header Dashboard & Filtros */}
                <div className={classes.dashboardHeader}>
                  <div className="Container-header">
                    <Typography className={classes.dashboardTitle}>Visão Geral</Typography>
                  </div>
                  <div className={classes.filterContainer}>
                    <Button
                      onClick={toggleShowFilter}
                      color="primary"
                      variant="text"
                      style={{ color: "#54656F", border: "1px solid #dbdbdb" }}
                    >
                      Filtros
                    </Button>
                  </div>
                </div>

                {showFilter && (
                  <div className={classes.filterSection}>
                    <Filters
                      classes={classes}
                      setDateStartTicket={setDateStartTicket}
                      setDateEndTicket={setDateEndTicket}
                      dateStartTicket={dateStartTicket}
                      dateEndTicket={dateEndTicket}
                      setQueueTicket={setQueueTicket}
                      queueTicket={queueTicket}
                      fetchData={setFetchDataFilter}
                    />
                  </div>
                )}

                {/* MainSection: Cards Principais */}
                <div>
                  <div className={classes.mainSection}>
                    {/* Card 1: Atendimento */}
                    <ComplexHeroCard
                      classes={classes}
                      title="Atendimentos"
                      icon={<i className="ri-customer-service-2-line" />}
                      mainValue={(counters.supportHappening || 0) + (counters.supportPending || 0)}
                      trendLabel="Atendimentos em aberto (geral)"
                    />
                    
                    {/* Card 2: Valores e Oportunidades */}
                    <ComplexHeroCard
                      classes={classes}
                      title="Total acumulado"
                      icon={<i className="ri-money-dollar-circle-line" />}
                      mainValue={formatCurrency(totalSalesValue)}
                      trendLabel="Valor total em vendas e negociações"
                    />

                    {/* Card 3: Em Negociação */}
                    <ComplexHeroCard
                      classes={classes}
                      title="Em Negociação"
                      icon={<i className="ri-hand-coin-line" />}
                      mainValue={formatCurrency(happeningSalesValue)}
                      trendLabel="Acumulado (tickets abertos/pendentes)"
                    />

                    {/* Card 4: T.M. Espera */}
                    <ComplexHeroCard
                      classes={classes}
                      title="T.M. Espera"
                      icon={<i className="ri-hourglass-line" />}
                      mainValue={formatTime(counters.avgWaitTime)}
                      trendLabel="Tempo médio de espera"
                    />
                  </div>
                </div>

                {/* Seção: Fluxo e Operação + NPS */}
                <div className={classes.sectionContainer}>
                  {/* Container 1: Fluxo e Operação (70%) */}
                  <div className={classes.fluxoContainer}>
                    <div className={classes.sectionHeader}>
                      <Typography className={classes.typographySubTitulos} style={{ display: 'flex', alignItems: 'center', gap: '5px', marginBottom: 0 }}>
                        <i className="ri-organization-chart" /> Fluxo e Operação
                      </Typography>
                    </div>
                    <div className={classes.fluxoCardsWrapper}>
                      {fluxoOperacaoData.map((item, index) => (
                        <div className={classes.fluxoCardItem} key={index}>
                          <Paper className={classes.metricCard} elevation={0}>
                            <div className={classes.metricCardIconWrapper}>
                              <i className={`${item.icon} ${classes.metricIcon}`} />
                            </div>
                            <Typography className={classes.metricValue}>{item.value}</Typography>
                            <Typography className={classes.metricLabel}>{item.label}</Typography>
                          </Paper>
                        </div>
                      ))}
                    </div>
                  </div>

                  {/* Container 2: Satisfação (30%) */}
                  <div className={classes.npsContainer}>
                    <div className={classes.sectionHeader}>
                      <Typography className={classes.typographySubTitulos} style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: 0 }}>
                        <i className="ri-star-line" /> Satisfação (NPS)
                      </Typography>
                    </div>
                    <Paper className={classes.npsCard} elevation={0}>
                      {npsData.map((item, index) => (
                        <div key={index} className={classes.npsItemContainer}>
                          <div className={classes.npsItemHeader}>
                            <Typography className={classes.npsItemLabel}>{item.label}</Typography>
                            <Typography className={classes.npsItemValue} style={{ color: item.color }}>
                              {item.isScore ? item.value : `${item.value}%`}
                            </Typography>
                          </div>
                          <LinearProgress
                            variant="determinate"
                            value={Number(item.value)}
                            className={classes.npsItemProgressBar}
                            style={{ backgroundColor: item.label === "Índice de Avaliação" || item.label === "Score Geral (NPS)" || item.label === "Promotores" || item.label === "Neutros" || item.label === "Detratores" ? 'rgba(157, 157, 157, 0.2)' : 'rgb(235, 235, 235)', height: 7 }}
                            sx={{ "& .MuiLinearProgress-bar": { backgroundColor: item.color } }}
                          />
                        </div>
                      ))}
                    </Paper>
                  </div>
                </div>

                {/* Nova Seção: Métricas de Conversão */}
                <div className={classes.conversionMetricsSection}>
                  <header className={classes.conversionMetricsHeader}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '16px', flexWrap: 'wrap' }}>
                      <Typography className={classes.conversionMetricsTitle}>
                        Métricas de Conversão
                      </Typography>
                      <div className={classes.conversionCardToggle}>
                        <button 
                          className={`${classes.conversionToggleBtn} ${viewMode === 'oportunidades' ? 'active' : ''}`}
                          onClick={() => setViewMode('oportunidades')}
                        >
                          Oportunidades (Tickets)
                        </button>
                        <button 
                          className={`${classes.conversionToggleBtn} ${viewMode === 'leads' ? 'active' : ''}`}
                          onClick={() => setViewMode('leads')}
                        >
                          Leads (Únicos)
                        </button>
                      </div>
                    </div>
                    <Button className={classes.conversionMetricsFiltersBtn} onClick={toggleShowFilter}>
                      <i className="ri-filter-3-line" style={{ marginRight: 4 }}></i> Filtros
                    </Button>
                  </header>

                  <div className={classes.conversionCardsContainer}>
                    {/* Card 1: Conversão Geral (Donut) */}
                    <Paper className={`${classes.conversionCard} ${classes.conversionCardLarge}`} elevation={0}>
                      {/* 1° Coluna: Métricas */}
                      <div className={classes.conversionCardCol}>
                        <Typography className={classes.conversionCardTitle}>Conversão Geral</Typography>
                        <Divider style={{ margin: "8px 0" }} />
                        <Typography style={{ fontWeight: 600, fontSize: "0.9rem", marginBottom: 8, color: theme.palette.text.primary }}>Métricas:</Typography>
                        
                        <div className={classes.metricListItem}>
                          <span style={{ fontSize: "0.85rem", color: theme.palette.text.secondary }}>{viewMode === 'oportunidades' ? 'Oportunidades (Tickets)' : 'Leads Únicos (Contatos)'}</span>
                          <span style={{ fontWeight: 600, color: theme.palette.text.primary }}>{mockConversionGeneral.total}</span>
                        </div>
                        <div className={classes.metricListItem}>
                          <span style={{ fontSize: "0.85rem", color: theme.palette.text.secondary }}>Total Aguardando</span>
                          <span style={{ fontWeight: 600, color: theme.palette.text.primary }}>{mockConversionGeneral.pendentes}</span>
                        </div>
                        <div className={classes.metricListItem}>
                          <span style={{ fontSize: "0.85rem", color: theme.palette.text.secondary }}>Total em Atendimento</span>
                          <span style={{ fontWeight: 600, color: theme.palette.text.primary }}>{mockConversionGeneral.abertos}</span>
                        </div>
                        <div className={classes.metricListItem}>
                          <span style={{ fontSize: "0.85rem", color: theme.palette.text.secondary }}>Total de Vendas</span>
                          <span style={{ fontWeight: 600, color: theme.palette.text.primary }}>{mockConversionGeneral.vendasFechadas}</span>
                        </div>
                        <div className={classes.metricListItem}>
                          <span style={{ fontSize: "0.85rem", color: theme.palette.text.secondary }}>Total de Fechados</span>
                          <span style={{ fontWeight: 600, color: theme.palette.text.primary }}>{mockConversionGeneral.fechados}</span>
                        </div>

                        <div className={classes.conversionRateBox}>
                          <span style={{ fontFamily: "'Poppins', sans-serif", fontSize: "1.2rem", fontWeight: 700, width: "100%", textAlign: "center" }}>
                            {mockConversionGeneral.taxaConversao}%
                          </span>
                        </div>
                      </div>

                      {/* 2° Coluna: Gráfico e Filtro */}
                      <div className={classes.conversionCardColRight}>
                        <div className={classes.conversionCardHeader}>
                          <Typography className={classes.conversionCardTitle}>
                            Vendas por {conversionToggle === 'fila' ? 'Fila' : 'Atendente'}
                          </Typography>
                          <div className={classes.conversionCardToggle}>
                            <button 
                              className={`${classes.conversionToggleBtn} ${conversionToggle === 'fila' ? 'active' : ''}`}
                              onClick={() => setConversionToggle('fila')}
                            >
                              Fila
                            </button>
                            <button 
                              className={`${classes.conversionToggleBtn} ${conversionToggle === 'atendente' ? 'active' : ''}`}
                              onClick={() => setConversionToggle('atendente')}
                            >
                              Atendente
                            </button>
                          </div>
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'center', margin: 'auto', paddingTop: '8px' }}>
                          <DonutChart 
                            title={bestName} 
                            value={bestRate} 
                            data={currentDonutData} 
                            color={donutColorPalette} 
                          />
                        </div>
                        {/* Legenda Customizada Exibindo Porcentagem de Cada Métrica */}
                        <div className={classes.customLegendContainer}>
                           {currentDonutData.map((item, idx) => {
                             const percent = totalDonutValue > 0 ? ((item.value / totalDonutValue) * 100).toFixed(1) : 0;
                             const formattedValue = isValueMode 
                               ? new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(item.value) 
                               : item.value;
                             return (
                               <div key={idx} className={classes.customLegendItem}>
                                 <div style={{ width: 8, height: 8, borderRadius: '50%', backgroundColor: donutColorPalette[idx % donutColorPalette.length] }}></div>
                                 <span>{item.name} = {formattedValue} ({percent}%)</span>
                               </div>
                             );
                           })}
                        </div>
                      </div>
                    </Paper>

                    {/* Card 2: Por Atendente */}
                    <Paper className={classes.conversionCard} elevation={0}>
                      <div className={classes.conversionCardHeader}>
                        <Typography className={classes.conversionCardTitle}>Por Atendente</Typography>
                      </div>
                      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-end", margin: "8px 0px" }}>
                        <span style={{ fontSize: "2rem", fontWeight: 700, color: theme.palette.primary.main, fontFamily: "'Poppins', sans-serif" }}>
                          {mediaTaxaAtendentes}%
                        </span>
                        <span style={{ fontSize: "0.7rem", color: theme.palette.text.secondary, fontFamily: "'Poppins', sans-serif" }}>Taxa Média dos Atendentes</span>
                      </div>
                      <Divider style={{ marginBottom: "8px" }} />
                      <div style={{ display: 'flex', justifyContent: 'space-between', padding: '0 8px', fontSize: '0.75rem', fontWeight: 600, color: theme.palette.text.secondary, fontFamily: "'Poppins', sans-serif" }}>
                        <span style={{ flex: 2 }}>Atendente</span>
                        <span style={{ flex: 1, textAlign: 'center' }}>Vendas</span>
                        <span style={{ flex: 1, textAlign: 'right' }}>Taxa</span>
                      </div>
                      <div className={classes.conversionList} style={{ marginTop: 4, maxHeight: 180 }}>
                        {mockConversionAtendentes.map((item, idx) => (
                          <div key={idx} className={classes.conversionListItem} style={{ padding: "8px" }}>
                            <span className={classes.conversionItemName} style={{ flex: 2 }}>{item.nome}</span>
                            <span className={classes.conversionItemValue} style={{ flex: 1, textAlign: 'center', fontSize: "0.85rem" }}>{item.vendas}</span>
                            <span style={{ flex: 1, textAlign: 'right', color: theme.palette.primary.main, fontWeight: 600, fontSize: "0.85rem", fontFamily: "'Poppins', sans-serif" }}>{item.taxa}</span>
                          </div>
                        ))}
                      </div>
                      <Divider style={{ margin: "8px 0", marginTop: "auto" }} />
                      <div className={classes.conversionTotalRow} style={{ paddingTop: 0, borderTop: "none" }}>
                        <span style={{ color: "#797e8c", fontWeight: 400 }}>{mockConversionGeneral.fechados} Total Finalizados</span>
                        <span>{mockConversionGeneral.vendasFechadas} Vendas Concluídas</span>
                      </div>
                    </Paper>

                    {/* Card 3: Por Fila */}
                    <Paper className={classes.conversionCard} elevation={0}>
                      <div className={classes.conversionCardHeader}>
                        <Typography className={classes.conversionCardTitle}>Por Fila</Typography>
                      </div>
                      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-end", margin: "8px 0px" }}>
                        <span style={{ fontSize: "2rem", fontWeight: 700, color: theme.palette.primary.main, fontFamily: "'Poppins', sans-serif" }}>
                          {mediaTaxaFilas}%
                        </span>
                        <span style={{ fontSize: "0.7rem", color: theme.palette.text.secondary, fontFamily: "'Poppins', sans-serif" }}>Taxa Média das Filas</span>
                      </div>
                      <Divider style={{ marginBottom: "8px" }} />
                      
                      {/* Informações das filas */}
                      <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', marginBottom: '8px' }}>
                        <div className={classes.metricListItem} style={{ borderBottom: 'none', padding: '2px 0' }}>
                          <span style={{ fontSize: "0.8rem", color: theme.palette.text.secondary }}>Em atendimento</span>
                          <span style={{ fontWeight: 600, color: theme.palette.text.primary, fontSize: "0.85rem" }}>{mockConversionGeneral.abertos}</span>
                        </div>
                        <div className={classes.metricListItem} style={{ borderBottom: 'none', padding: '2px 0' }}>
                          <span style={{ fontSize: "0.8rem", color: theme.palette.text.secondary }}>Finalizados</span>
                          <span style={{ fontWeight: 600, color: theme.palette.text.primary, fontSize: "0.85rem" }}>{mockConversionGeneral.fechados}</span>
                        </div>
                        <div className={classes.metricListItem} style={{ borderBottom: 'none', padding: '2px 0' }}>
                          <span style={{ fontSize: "0.8rem", color: theme.palette.text.secondary }}>Aguardando</span>
                          <span style={{ fontWeight: 600, color: theme.palette.text.primary, fontSize: "0.85rem" }}>{mockConversionGeneral.pendentes}</span>
                        </div>
                      </div>
                      <Divider style={{ marginBottom: "8px" }} />

                      {/* Tabela de filas */}
                      <div style={{ display: 'flex', justifyContent: 'space-between', padding: '0 8px', fontSize: '0.75rem', fontWeight: 600, color: theme.palette.text.secondary, fontFamily: "'Poppins', sans-serif" }}>
                        <span style={{ flex: 2 }}>Fila</span>
                        <span style={{ flex: 1, textAlign: 'right' }}>Taxa</span>
                      </div>
                      <div className={classes.conversionList} style={{ marginTop: 4, maxHeight: 180 }}>
                        {mockConversionFilas.map((item, idx) => (
                          <div key={idx} className={classes.conversionListItem} style={{ padding: "8px" }}>
                            <div style={{ flex: 2 }}>
                              <span style={{ backgroundColor: item.color || theme.palette.primary.main, color: "#fff", padding: "4px 8px", borderRadius: "8px", fontSize: "0.75rem", fontWeight: 600 }}>
                                {item.nome}
                              </span>
                            </div>
                            <span style={{ flex: 1, textAlign: 'right', color: theme.palette.primary.main, fontWeight: 600, fontSize: "0.85rem", fontFamily: "'Poppins', sans-serif" }}>{item.taxa}</span>
                          </div>
                        ))}
                      </div>
                    </Paper>
                  </div>
                </div>

                {/* Nova Seção: Qualificação de Leads */}
                {user.finalizacaoComValorVendaAtiva && (
                  <div className={classes.conversionMetricsSection}>
                    <header className={classes.conversionMetricsHeader}>
                      <Typography className={classes.conversionMetricsTitle}>
                        Qualificação de Leads (SQL)
                      </Typography>
                    </header>
                    <Paper className={`${classes.conversionCard} ${classes.conversionCardLarge}`} elevation={0}>
                      {/* 1° Coluna: Gráfico de Donut (Motivos de Desqualificação) */}
                      <div className={classes.conversionCardCol}>
                        <div className={classes.conversionCardHeader} style={{ justifyContent: 'center' }}>
                          <Typography className={classes.conversionCardTitle}>
                            Distribuição de Desqualificações
                          </Typography>
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'center', margin: 'auto', paddingTop: '8px' }}>
                          <DonutChart 
                            title="Desqualificados" 
                            value={counters.qualification?.totalDisqualified || 0} 
                            data={counters.qualification?.disqualificationReasons?.length > 0 ? counters.qualification.disqualificationReasons.map(r => ({ name: r.reason, value: r.count })) : [{ name: "Sem desqualificações", value: 1 }]} 
                            color={redDonutColorPalette} 
                            valueColor="#EF4444"
                          />
                        </div>
                        <div className={classes.customLegendContainer}>
                           {counters.qualification?.disqualificationReasons?.map((item, idx) => (
                             <div key={idx} className={classes.customLegendItem}>
                               <div style={{ width: 8, height: 8, borderRadius: '50%', backgroundColor: redDonutColorPalette[idx % redDonutColorPalette.length] }}></div>
                               <span>{item.reason} = {item.count} ({item.percent}%)</span>
                             </div>
                           ))}
                        </div>
                      </div>

                      {/* 2° Coluna: Taxa de Qualificação e Top 10 */}
                      <div className={classes.conversionCardColRight}>
                        <div className={classes.conversionCardHeader}>
                          <Typography className={classes.conversionCardTitle}>Taxa de Qualificação</Typography>
                        </div>
                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-end", margin: "8px 0px" }}>
                          <span style={{ fontSize: "2rem", fontWeight: 700, color: theme.palette.primary.main, fontFamily: "'Poppins', sans-serif" }}>
                            {counters.qualification?.qualificationRate || "0.0"}%
                          </span>
                          <span style={{ fontSize: "0.7rem", color: theme.palette.text.secondary, fontFamily: "'Poppins', sans-serif" }}>Leads Qualificados (SQL)</span>
                        </div>
                        <Divider style={{ marginBottom: "8px" }} />

                        {/* Qualificados */}
                        <Typography style={{ fontSize: "0.85rem", fontWeight: 600, color: "#10B981", marginBottom: "4px", fontFamily: "'Poppins', sans-serif" }}>
                          Top 5 Qualificações
                        </Typography>
                        <div style={{ display: 'flex', justifyContent: 'space-between', padding: '0 8px', fontSize: '0.7rem', fontWeight: 600, color: theme.palette.text.secondary, fontFamily: "'Poppins', sans-serif" }}>
                          <span style={{ flex: 2 }}>Motivo</span>
                          <span style={{ flex: 1, textAlign: 'center' }}>Qtd</span>
                          <span style={{ flex: 1, textAlign: 'right' }}>%</span>
                        </div>
                        <div className={classes.conversionList} style={{ marginTop: 2, maxHeight: 130, marginBottom: 8 }}>
                          {counters.qualification?.qualificationReasons?.map((item, idx) => (
                            <div key={idx} className={classes.conversionListItem} style={{ padding: "6px 8px", minHeight: "unset" }}>
                              <span className={classes.conversionItemName} style={{ flex: 2, fontSize: "0.8rem" }}>{item.reason}</span>
                              <span className={classes.conversionItemValue} style={{ flex: 1, textAlign: 'center', fontSize: "0.8rem" }}>{item.count}</span>
                              <span style={{ flex: 1, textAlign: 'right', color: "#10B981", fontWeight: 600, fontSize: "0.8rem", fontFamily: "'Poppins', sans-serif" }}>{item.percent}%</span>
                            </div>
                          ))}
                          {(!counters.qualification?.qualificationReasons || counters.qualification.qualificationReasons.length === 0) && (
                            <div className={classes.conversionListItem} style={{ padding: "6px 8px", justifyContent: 'center', minHeight: "unset" }}>
                              <span className={classes.conversionItemName} style={{ fontSize: "0.8rem" }}>Nenhuma qualificação</span>
                            </div>
                          )}
                        </div>

                        <Divider style={{ marginBottom: "8px" }} />

                        {/* Desqualificados */}
                        <Typography style={{ fontSize: "0.85rem", fontWeight: 600, color: "#EF4444", marginBottom: "4px", fontFamily: "'Poppins', sans-serif" }}>
                          Top 5 Desqualificações
                        </Typography>
                        <div style={{ display: 'flex', justifyContent: 'space-between', padding: '0 8px', fontSize: '0.75rem', fontWeight: 600, color: theme.palette.text.secondary, fontFamily: "'Poppins', sans-serif" }}>
                          <span style={{ flex: 2 }}>Motivo</span>
                          <span style={{ flex: 1, textAlign: 'center' }}>Qtd</span>
                          <span style={{ flex: 1, textAlign: 'right' }}>%</span>
                        </div>
                        <div className={classes.conversionList} style={{ marginTop: 2, maxHeight: 130 }}>
                          {counters.qualification?.disqualificationReasons?.map((item, idx) => (
                            <div key={idx} className={classes.conversionListItem} style={{ padding: "6px 8px", minHeight: "unset" }}>
                              <span className={classes.conversionItemName} style={{ flex: 2, fontSize: "0.8rem" }}>{item.reason}</span>
                              <span className={classes.conversionItemValue} style={{ flex: 1, textAlign: 'center', fontSize: "0.8rem" }}>{item.count}</span>
                              <span style={{ flex: 1, textAlign: 'right', color: "#EF4444", fontWeight: 600, fontSize: "0.8rem", fontFamily: "'Poppins', sans-serif" }}>{item.percent}%</span>
                            </div>
                          ))}
                          {(!counters.qualification?.disqualificationReasons || counters.qualification.disqualificationReasons.length === 0) && (
                            <div className={classes.conversionListItem} style={{ padding: "6px 8px", justifyContent: 'center', minHeight: "unset" }}>
                              <span className={classes.conversionItemName} style={{ fontSize: "0.8rem" }}>Nenhuma desqualificação</span>
                            </div>
                          )}
                        </div>

                        <Divider style={{ margin: "8px 0", marginTop: "auto" }} />
                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", paddingTop: "4px", fontWeight: 600, fontSize: "0.8rem", fontFamily: "'Poppins', sans-serif" }}>
                          <span style={{ color: "#10B981" }}>{counters.qualification?.totalQualified || 0} Qualificados</span>
                          <span style={{ color: "#EF4444" }}>{counters.qualification?.totalDisqualified || 0} Desqualif.</span>
                          <span style={{ color: theme.palette.text.primary }}>{counters.qualification?.totalEvaluated || 0} Fechados</span>
                        </div>
                      </div>
                    </Paper>
                  </div>
                )}

                {/* Tabela de Atendentes */}
                <div className={classes.tableContainer}>
                  <Typography className={classes.typographySubTitulos}>Atendentes</Typography>
                  <Paper className={classes.tablePaper} elevation={0}>
                    <TableAttendantsStatus
                      attendants={attendants}
                      loading={loading}
                    />
                  </Paper>
                </div>

                {/* Tabela de Desempenho Comercial por Usuário */}
                <div className={classes.tableContainer}>
                  <Paper className={classes.tablePaper} elevation={0} style={{ padding: 0 }}>
                    <TableUserValues />
                  </Paper>
                </div>

                {/* Gráficos */}
                <div className={classes.chartsContainer}>
                  <div className={classes.chartItem} style={{ flex: "1 1 100%" }}>
                    <Paper className={classes.chartPaper} elevation={0}>
                      <ChartsSalesLine />
                    </Paper>
                  </div>
                  <div className={classes.chartItem}>
                    <Paper className={classes.chartPaper} elevation={0}>
                      <ChatsUser />
                    </Paper>
                  </div>
                  <div className={classes.chartItem}>
                    <Paper className={classes.chartPaper} elevation={0}>
                      <ChartsDate />
                    </Paper>
                  </div>
                </div>
              </div>
            </Container>
          </Paper>
        </MainContainer>
      )}
    </>
  );
};

export default Dashboard;